// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsListFeature":"wg_a bhj_b","TwoDimsListFeature__item":"wg_b bhj_ux","TwoDimsListFeature__item__text":"wg_c bhj_un"};